export const useSxStyles = () => {
  return {
    wrapper: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr ',
      gridTemplateRows: '1fr auto',
      gridTemplateAreas: `
        "approvals form"
      `,
      gap: 2,
      '& > .form': {
        gridArea: 'form',
      },
      '& > .approvals': {
        gridArea: 'approvals',
        minWidth: '320px',
      },
    },
    accordionSummary: {
      '& .MuiAccordionSummary-content': {
        '&, &.Mui-expanded': {
          margin: 0,
        },
      },
      '&.lockedExpanded.Mui-expanded': {
        userSelect: 'initial',
        '&, &:hover:not(.Mui-disabled)': {
          cursor: 'default',
        },
      },
    },
    accordionSummaryItems: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& button': {
        marginRight: '1em',
      },
    },
    accordionDetails: {
      padding: 2,
    },
  };
};
